export default __webpack_public_path__ + "static/media/banner-2.8c8f81be.PNG";